import { css } from 'styled-components';

import { FullPalette } from '@grnhse/seedling/lib/birch/colors';
import Tokens from '@grnhse/seedling/lib/birch/tokens';

const CHAT_MESSAGE_MAX_WIDTH = '332px';

export const chatMessageTextStyles = css`
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.43;
  color: ${FullPalette.EVERGREEN_700};
`;

const chatMessageBubbleBaseStyles = css`
  ${chatMessageTextStyles}
  max-width: ${CHAT_MESSAGE_MAX_WIDTH};
  padding: ${Tokens.spacing['1.5']} ${Tokens.spacing['2']};
  border-radius: ${Tokens.spacing['1']};
  word-break: break-word;
`;

export const assistantMessageBubbleStyles = css`
  ${chatMessageBubbleBaseStyles}
  background: ${FullPalette.GREY_E25};
`;

export const assistantMessageContentStyles = css`
  a {
    font-size: 0.875rem !important;
  }

  p {
    font-size: inherit;
    line-height: inherit;
    margin: 0 0 ${Tokens.spacing['2']} 0;
    &:last-child {
      margin-bottom: 0;
    }
  }

  strong {
    font-weight: 600;
  }
  em {
    font-style: italic;
  }

  ul {
    font-size: inherit;
    line-height: inherit;
    list-style-type: disc;
    margin: 0 0 ${Tokens.spacing['2']} 0;
    padding-left: ${Tokens.spacing['4']};
    &:last-child {
      margin-bottom: 0;
    }
  }

  ol {
    font-size: inherit;
    line-height: inherit;
    list-style-type: decimal;
    margin: 0 0 ${Tokens.spacing['2']} 0;
    padding-left: ${Tokens.spacing['4']};
    &:last-child {
      margin-bottom: 0;
    }
  }

  li {
    font-size: inherit;
    line-height: inherit;
    margin-bottom: ${Tokens.spacing['0.5']};
  }

  code {
    font-family: ui-monospace, monospace;
    font-size: 0.875em;
    background: ${FullPalette.GREY_E500};
    padding: 0.1em 0.35em;
    border-radius: 4px;
  }

  pre {
    background: ${FullPalette.GREY_E500};
    border-radius: ${Tokens.spacing['1']};
    padding: ${Tokens.spacing['2']};
    overflow-x: auto;
    white-space: pre-wrap;
    word-break: break-all;
    margin: 0 0 ${Tokens.spacing['2']} 0;
    &:last-child {
      margin-bottom: 0;
    }

    code {
      background: none;
      padding: 0;
      font-size: 0.875rem;
    }
  }

  blockquote {
    font-size: inherit;
    line-height: inherit;
    border-left: 3px solid ${FullPalette.GREY_700};
    margin: 0 0 ${Tokens.spacing['2']} 0;
    padding-left: ${Tokens.spacing['2']};
    color: ${FullPalette.GREY_800};
    &:last-child {
      margin-bottom: 0;
    }
  }

  h1,
  h2,
  h3,
  h4 {
    font-weight: 600;
    margin: ${Tokens.spacing['2']} 0 ${Tokens.spacing['1']} 0;
    &:first-child {
      margin-top: 0;
    }
  }
`;

export const userMessageBubbleStyles = css`
  ${chatMessageBubbleBaseStyles}
  background: ${FullPalette.WHITE};
  border: 1px solid ${FullPalette.GREY_E500};
  border-radius: ${Tokens.spacing['2']} ${Tokens.spacing['2']} 0
    ${Tokens.spacing['2']};
  white-space: pre-wrap;
`;
